import React, { useState } from "react";
import "./Header.css";
import "./global.css";
import logo from "../images/gyctc-logo.png";
import { Link, useNavigate } from "react-router-dom";
const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  return (
    <>
      <div className="nav">
        <div className="nav-items">
          <div className="logo">
            <img src={logo} alt="GYCTC logo" />
            <a href="#home">GYCTC</a>
          </div>
          <div className="menu" onClick={() => setIsNavOpen(!isNavOpen)}>
            {!isNavOpen ? (
              <>
                <span></span>
                <span></span>
                <span></span>
              </>
            ) : (
              <i className="fa-solid fa-xmark fa-2xl"></i>
            )}
          </div>
          <div className="nav-item">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdde1RPeGuya6eg4HDVhfsUG5ul9BmbJB9nQUhBJu3dA9v72g/viewform"
              target="_blank"
            >
              Apply
            </a>
            <a href="#home">Home</a>
            <a href="#our-courses">Courses</a>
            <a href="#instructor">Instructor</a>
            <a href="#contactus">Contact Us</a>
          </div>
        </div>
      </div>
      <div className="mobile-nav" id={isNavOpen ? "open" : "close"}>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSdde1RPeGuya6eg4HDVhfsUG5ul9BmbJB9nQUhBJu3dA9v72g/viewform"
          target="_blank"
          onClick={() => setIsNavOpen(!isNavOpen)}
        >
          Apply
        </a>
        <a href="#home" onClick={() => setIsNavOpen(!isNavOpen)}>
          Home
        </a>
        <a href="#our-courses" onClick={() => setIsNavOpen(!isNavOpen)}>
          Courses
        </a>
        <a href="#instructor" onClick={() => setIsNavOpen(!isNavOpen)}>
          Instructor
        </a>
        <a href="#contactus" onClick={() => setIsNavOpen(!isNavOpen)}>
          Contact Us
        </a>
      </div>
    </>
  );
};

export default Header;
